export default (form) => {
    // Validate required checkboxes (1 or more checked)
    const checkboxesToValidate = Array.from(form.querySelectorAll('.js-validate-checkboxes'));

    const validateRequiredCheckboxes = () => {
        checkboxesToValidate.forEach((group) => {
            const hiddenInput = group.querySelector('.js-checkbox-validation-flag');
            if (!hiddenInput) return;
            const inputs = Array.from(group.querySelectorAll('input:not(.js-checkbox-validation-flag)'));
            let checkboxFound = false;
            inputs.forEach((checkbox) => {
                checkboxFound = (checkbox.checked ? true : checkboxFound);
            });
            hiddenInput.setCustomValidity(checkboxFound ? '' : 'Please select at least one checkbox');
            hiddenInput.checked = checkboxFound;
        });
    };

    if (checkboxesToValidate) form.addEventListener('change', () => validateRequiredCheckboxes());
};
